import { Pathname } from "history";
import { FuseNavItemType } from "./types/FuseNavItemType";

/**
 * Determina se uma determinada URL está presente (ou não) na lista de filhos do item pai.
 */
const isUrlInChildren = (parent: FuseNavItemType, url: Pathname) => {
	if (!parent.children) {
		return false;
	}

	for (const navItem of parent.children) {
		if (navItem.children) {
			if (isUrlInChildren(navItem, url)) {
				return true;
			}
		}

		if (navItem.url === url || url.includes(navItem.url)) {
			return true;
		}
	}

	return false;
};

export default isUrlInChildren;
